import { BadgeGoals as BadgeGoalsComponent } from "./BadgeGoals.component";

export const BadgeGoals = BadgeGoalsComponent;

